import styled from 'styled-components';
import IconChevronDownCircle from './IconChevronDownCircle';
var IconChevronUpCircle = /*#__PURE__*/styled(IconChevronDownCircle).withConfig({
  displayName: "IconChevronUpCircle",
  componentId: "c11n-8-111-1__sc-znn58v-0"
})(["transform:rotate(180deg);"]);
export default IconChevronUpCircle;